
  var fc_play_button = document.getElementsByClassName("fc_icon_play");
  var fc_video_cover_image = document.getElementsByClassName("fc_video_cover_image");                                                           
  var fc_video = document.getElementsByClassName("fc_video");

   
  var fc_video_autoplay = document.getElementsByClassName("fc_video_autoplay"); 
  var fc_video_autoplay_button = document.getElementsByClassName("fc_video_autoplay_button");
  var fc_video_autoplay_image = document.getElementsByClassName("fc_video_autoplay_image");
    
   
      for(let k=0; k < fc_video_autoplay_button.length; k++){
        fc_video_autoplay_button[k].style.display = "none";
        fc_video_autoplay_image[k].style.display = "none";
        fc_video_autoplay[k].play();
    }
 
   
  for(let i=0; i < fc_play_button.length; i++){
    fc_play_button[i].onclick = () => {
      fc_play_button[i].style.display = "none";
      fc_video_cover_image[i].style.display = "none";
      fc_video[i].play();     
    }
  }

  
